import React from 'react'

const AutomationOptionsDeviceAction = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="54" height="50" viewBox="0 0 54 50" fill="none" className={className}>
    <path
      d="M20.4805 25.0801V14.6801L29.4805 19.8801L38.4905 25.0801L29.4805 30.2801L20.4805 35.4801V25.0801Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M40.731 5.89002C36.7398 3.02944 31.9514 1.49392 27.041 1.50002C20.7872 1.50002 14.7895 3.98433 10.3674 8.40644C5.94527 12.8285 3.46095 18.8262 3.46095 25.08C3.45612 29.9933 4.99144 34.7846 7.85096 38.78"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M13.3398 44.27C17.3347 47.1307 22.1263 48.6662 27.0399 48.66C33.2937 48.66 39.2913 46.1757 43.7134 41.7536C48.1355 37.3315 50.6199 31.3338 50.6199 25.08C50.6247 20.1667 49.0894 15.3755 46.2299 11.38"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M43.9004 17.88L45.9704 10.92L52.9304 12.99" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M10.1706 32.29L8.10063 39.25L1.14062 37.17" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
)

export default AutomationOptionsDeviceAction
